$(function() {
    "use strict";

    $(document).on('ready', function () {
        var $items = $('.sign-up-panel');
        var $footer = $('.footer');
        var $crosslinkPane = $('.crosslink-pane');
        var footerHeight = $crosslinkPane.outerHeight(true) + $footer.outerHeight(true);
        var windowHeight = $(window).height();

        $items.each(function () {
            var $root = $(this);
            $root.parents('.sign-up-panel__root').each(function () {
                $root.push(this);
            });

            var $closer = $root.find('.sign-up-panel__close');

            var mark = $root.attr('id') ? $root.attr('id') : 'mark';

            if (!$.jStorage.get(mark, false)) {
                $root.removeClass('sign-up-panel_hidden');

                $root.each(function () {
                    if ($(this).is('.sign-up-panel_top')) {
                        $(this).sticky({
                            topSpacing: $('.header__top-line').outerHeight(true) + $('.header__bottom-line').outerHeight(true)
                        });

                        var reheight = function () {
                            return $root.parent().height($root.outerHeight() + parseInt($root.css('margin-bottom')));
                        };
                        reheight();

                        $(window).on('debouncedresize.SignUpPanel', function() {
                            reheight();
                        });
                    }
                });
            }

            $closer.on('click', function () {
                $root.addClass('sign-up-panel_hidden');
                $root.parent().height(0);

                if (!$.jStorage.get(mark, false)) {
                    $.jStorage.set(mark, true, { TTL : 3600000 });
                }
            });

            if ($root.is('.sign-up-panel_top:visible' )) {
            }
        });
    });
});

